import React, { FC, useEffect, useState } from 'react'
import Modal from '@mui/material/Modal'
import TextField from '@mui/material/TextField'
import Divider, { dividerClasses } from '@mui/material/Divider'
import classes from './RecordDetailForm.module.scss'
import {
  colorSelectRuturnCode,
  colorSelectRuturnCodeLite,
} from '../../commons/columnColor'
import { useRecoilValue } from 'recoil'
import { userState } from '../../states/userState'
import {
  backColorModal,
  backGroundColorCode,
  backgroundColor,
} from '../../commons/colors'
type Props = {
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>
  data: any
}
const RecordDetailForm: FC<Props> = (props) => {
  const { setIsShow, data } = props
  const user = useRecoilValue(userState)
  //ダイアログの操作
  const [open, setOpen] = useState(true)
  //キャンセル
  const handleCancelButtonClick = () => {
    // setSendArray([]);
    setOpen(false)
    setIsShow(false)
  }
  const createData = (data: any, identifer: string) => {
    return data
      .map((row: any) => {
        const item = row.getContext()
        return item.column.id.startsWith(identifer)
          ? { id: item.column.id, text: item.getValue() }
          : null
      })
      .filter((item: any) => item !== null)
  }
  //配列の初期化
  const baseData = createData(data, 'B_')
  const processPtData = createData(data, 'PT_')
  const processPvData = createData(data, 'PV_')
  const siteData = createData(data, 'S_')
  const productNo =
    baseData.find((p: { id: string; text: string }) => p.id === 'B_製番')
      ?.text ?? ''
  const siteName =
    baseData.find((p: { id: string; text: string }) => p.id === 'B_現場名')
      ?.text ?? ''

  const isMultiLine = (name: string) => {
    if (name === '現場名' || name === '備考') {
      return true
    }
  }
  const dateRegex = /^\d{4}-\d{2}-\d{2}[A-Za-z]+$/
  const isFinished = (text: string) => {
    return dateRegex.test(text)
  }

  // console.log("baseData", baseData, colorSelectRuturnCode("B_"));
  const dividerStyle = (color: string) => {
    let styles = {
      borderColor: `${color}`, // 線の色をテーマのプライマリーカラーに設定
      fontSize: '18px',
      marginBottom: '0px',
      // Dividerにテキストがある場合、テキストのスタイルもここで定義できます
      '&::before, &::after': {
        // Dividerの線のスタイルをカスタマイズ
        borderTopColor: `${color}`, // これにより、線の色が変わります
      },
      color: `${color}`, // テキストの色を変更
      '@media (max-width: 600px)': {
        fontSize: '14px', // フォントサイズを14pxに設定
      },
    }
    return styles
  }
  const inputStyle = (name: string, color: string) => {
    let styles = {
      '&&&': {
        color: `${color}`,
        width: '230px',
        margin: '0 0 0 0',
        // backgroundColor:"#dedede",
        '@media (max-width: 600px)': {
          width: '110px', // デフォルトの幅を110pxに設定
        },
      },
      '& input': {
        paddingTop: 0,
        paddingBottom: 0,
        padding: ' 0 2px',
        fontSize: '12px',
        height: '36px',
        color: `${color}`,
        border: `1px solid ${color}`,
        textAlign: 'center',
        borderRadius: '5px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '@media (max-width: 600px)': {
          fontSize: '11.5px', // フォントサイズを14pxに設定
          height: '30px',
        },
      },
      '& .MuiInputBase-input': {
        color: `${color}`, // 入力文字の色
        backgroundColor: backGroundColorCode(user?.mode ?? 'lite'),
        // #202226",
      },
      '& label': {
        fontSize: '16px',
        color: `${color}`, // 通常時のラベル色
        '@media (max-width: 600px)': {
          fontSize: '14px', // フォントサイズを14pxに設定
        },
        //backgroundColor:"white"
      },
      '& label.Mui-focused': {
        color: `${color}`, // ラベルの色`${color}`指定
      },
      '& .MuiInput-underline:before': {
        borderBottomColor: `${color}`, // 通常時のボーダー色
      },
      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: `${color}`, // ホバー時のボーダー色
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: `${color}`, // 通常時のボーダー色(アウトライン)
        },
        '&:hover fieldset': {
          borderColor: `${color}`, // ホバー時のボーダー色(アウトライン)
        },
      },
    }
    if (name.includes('日時') || name === '仕上名') {
      styles['&&&'].width = '120px'
      styles['&&&']['@media (max-width: 600px)'] = { width: '100px' }
    } else if (
      name === '製作工場名' ||
      name === '出荷工場名' ||
      name === '製番' ||
      name === '製作番号' ||
      name === '事業所名'
    ) {
      styles['&&&'].width = '90px'
      styles['&&&']['@media (max-width: 600px)'] = { width: '80px' }
    } else if (
      name === '担当名' ||
      name === '得意先名' ||
      name === '品目区分名'
    ) {
      styles['&&&'].width = '160px'
      styles['&&&']['@media (max-width: 600px)'] = { width: '120px' }
    } else if (
      name === '状況区分名' ||
      name === '受架台入荷' ||
      name === '手摺タラ入荷'
    ) {
      styles['&&&'].width = '90px'
      styles['&&&']['@media (max-width: 600px)'] = { width: '80px' }
    } else if (name === '保温名') {
      styles['&&&'].width = '120px'
      styles['&&&']['@media (max-width: 600px)'] = { width: '100px' }
    } else {
      // 他の条件に基づいて必要ならばここで調整
      styles['&&&'].width = '70px' // この行はデフォルトの幅設定と同じなので、実際には不要かもしれません
      styles['&&&']['@media (max-width: 600px)'] = { width: '65px' }
    }

    return styles
  }
  const inputStyleProcess = (
    name: string,
    color: string,
    isFinished: boolean
  ) => {
    let styles = {
      '&&&': {
        color: `${color}`,
        width: '230px',
        '@media (max-width: 600px)': {
          width: '110px', // デフォルトの幅を110pxに設定
        },
        margin: '0 0 0 0',
        // backgroundColor:"#dedede",
      },
      '& input': {
        paddingTop: 0,
        paddingBottom: 0,
        padding: ' 0 2px',
        fontSize: '12px',
        height: '36px',
        color: `${color}`,
        border: `1px solid ${color}`,
        textAlign: 'center',
        borderRadius: '5px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '@media (max-width: 600px)': {
          fontSize: '11.5px', // フォントサイズを14pxに設定
          height: '30px',
        },
      },
      '& .MuiInputBase-input': {
        color: isFinished ? '#00556f' : `${color}`, // 入力文字の色
        backgroundColor: isFinished
          ? '#b3fea1'
          : backGroundColorCode(user?.mode ?? 'lite'),
      },
      '& label': {
        fontSize: '16px',
        color: `${color}`, // 通常時のラベル色
        '@media (max-width: 600px)': {
          fontSize: '14px', // フォントサイズを14pxに設定
        },
        //backgroundColor:"white"
      },
      '& label.Mui-focused': {
        color: `${color}`, // ラベルの色`${color}`指定
      },
      '& .MuiInput-underline:before': {
        borderBottomColor: `${color}`, // 通常時のボーダー色
      },
      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: `${color}`, // ホバー時のボーダー色
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: `${color}`, // 通常時のボーダー色(アウトライン)
        },
        '&:hover fieldset': {
          borderColor: `${color}`, // ホバー時のボーダー色(アウトライン)
        },
      },
    }
    if (name.includes('日時')) {
      styles['&&&'].width = '120px'
      styles['&&&']['@media (max-width: 600px)'] = { width: '110px' }
    } else if (name === '製番' || name === '製作番号') {
      styles['&&&'].width = '90px'
      styles['&&&']['@media (max-width: 600px)'] = { width: '80px' }
    } else {
      // 他の条件に基づいて必要ならばここで調整
      styles['&&&'].width = '100px' // この行はデフォルトの幅設定と同じなので、実際には不要かもしれません
      styles['&&&']['@media (max-width: 600px)'] = { width: '70px' }
    }

    return styles
  }
  const inputStyleSite = (name: string, color: string, isFinished: boolean) => {
    let styles = {
      '&&&': {
        color: `${color}`,
        width: '230px',
        margin: '0 0 0 0',
        // backgroundColor:"#dedede",
      },
      '& input': {
        paddingTop: 0,
        paddingBottom: 0,
        padding: ' 0 2px',
        fontSize: '12px',
        height: '36px',
        color: `${color}`,
        border: `1px solid ${color}`,
        textAlign: 'center',
        borderRadius: '5px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '@media (maxWidth: 600px)': {
          fontSize: '11.5px', // フォントサイズを14pxに設定
          height: '30px',
        },
      },
      '& .MuiInputBase-input': {
        color: isFinished ? '#00556f' : `${color}`, // 入力文字の色
        backgroundColor: isFinished
          ? '#b3fea1'
          : backGroundColorCode(user?.mode ?? 'lite'),
      },
      '& label': {
        fontSize: '16px',
        color: `${color}`, // 通常時のラベル色
        '@media (max-width: 600px)': {
          fontSize: '14px', // フォントサイズを14pxに設定
        },
        //backgroundColor:"white"
      },
      '& label.Mui-focused': {
        color: `${color}`, // ラベルの色`${color}`指定
      },
      '& .MuiInput-underline:before': {
        borderBottomColor: `${color}`, // 通常時のボーダー色
      },
      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: `${color}`, // ホバー時のボーダー色
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: `${color}`, // 通常時のボーダー色(アウトライン)
        },
        '&:hover fieldset': {
          borderColor: `${color}`, // ホバー時のボーダー色(アウトライン)
        },
      },
    }
    if (name.includes('日時')) {
      styles['&&&'].width = '120px'
    } else if (name === '製番' || name === '製作番号' || name === '工事種名') {
      styles['&&&'].width = '90px'
    } else {
      // 他の条件に基づいて必要ならばここで調整
      styles['&&&'].width = '80px' // この行はデフォルトの幅設定と同じなので、実際には不要かもしれません
    }

    return styles
  }
  const inputMultiStyle = (name: string, color: string) => {
    let styles = {
      backgroundColor: backGroundColorCode(user?.mode ?? 'lite'),
      borderRadius: '5px',
      fontSize: '14px',
      padding: '0 2px',
      width: '160px',
      '@media (max-width: 600px)': {
        fontSize: '12px', // フォントサイズを14pxに設定
        width: '120px',
      },
      '&&&': {
        padding: '0 2px',
      },
      '& .MuiInputBase-input': {
        color: `${color}`, // 入力文字の色
        fontSize: '12px',
        padding: '0 2px',
        '@media (max-width: 600px)': {
          fontSize: '10px', // フォントサイズを14pxに設定
        },
      },
      //スピンボタンの無効化-効いていない
      ':global(input[type="number"]::-webkit-outer-spin-button)': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      ':global(input[type="number"]::-webkit-inner-spin-button)': {
        WebkitAppearance: 'none',
        margin: 0,
      },

      '& label': {
        color: `${color}`, // 通常時のラベル色
        //backgroundColor:"white"
        fontSize: '14px',
        '@media (max-width: 600px)': {
          fontSize: '12px', // フォントサイズを14pxに設定
        },
      },
      '& label.Mui-focused': {
        color: `${color}`, // ラベルの色をprimary.mainに指定
      },
      '& .MuiInput-underline:before': {
        borderBottomColor: `${color}`, // 通常時のボーダー色
      },
      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: `${color}`, // ホバー時のボーダー色
      },

      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: `${color}`, // 通常時のボーダー色(アウトライン)
        },
        '&:hover fieldset': {
          borderColor: `${color}`, // ホバー時のボーダー色(アウトライン)
        },
        '& .MuiInputBase-root': {
          padding: '0 2px',
        },
        '&.css-lc33rk-MuiInputBase-root-MuiOutlinedInput-root': {
          padding: '2px 2px',
          minHeight: '60px',
        },
      },
    }

    return styles
  }
  // console.log("processPvData", processPvData);

  return (
    <Modal
      open={open}
      onClose={handleCancelButtonClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: 'prmary.main',
        border: 'none',
        '&:focus-visible': {
          borderColor: 'prmary.main',
          outlineColor: 'primary.main', // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <div
        className={classes.formContainer}
        style={backColorModal(user?.mode ?? 'lite')}
        // onClick={handleCancelButtonClick}
      >
        <div
          className={classes.info}
          style={dividerStyle(
            user?.mode === 'lite'
              ? colorSelectRuturnCodeLite('B_')
              : colorSelectRuturnCode('B_')
          )}
        >
          <div className={classes.infoItem} style={{ marginRight: '10px' }}>
            <p>製番</p>
            <p className={classes.productNo}>{productNo}</p>
          </div>
          <div className={classes.infoItem}>
            <p>現場名</p>
            <p className={classes.site}>{siteName}</p>
          </div>
        </div>
        {processPtData.length > 0 && (
          <div className={classes.mainContents}>
            <Divider
              textAlign="left"
              sx={dividerStyle(
                user?.mode === 'lite'
                  ? colorSelectRuturnCodeLite('PT_')
                  : colorSelectRuturnCode('PT_')
              )}
              variant="fullWidth"
            >
              工程情報
            </Divider>
            <div className={classes.content}>
              {processPtData.map((item: any) => (
                <div key={item.id}>
                  <TextField
                    label={item.id.split('_')[1]}
                    variant="outlined"
                    value={item.text}
                    InputProps={{ readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                    sx={
                      !isMultiLine(item.id.split('_')[1])
                        ? inputStyleProcess(
                            item.id.split('_')[1],
                            user?.mode === 'lite'
                              ? colorSelectRuturnCodeLite('PT_')
                              : colorSelectRuturnCode('PT_'),
                            isFinished(item.text)
                          )
                        : inputMultiStyle(
                            item.id.split('_')[1],
                            user?.mode === 'lite'
                              ? colorSelectRuturnCodeLite('PT_')
                              : colorSelectRuturnCode('PT_')
                          )
                    }
                    multiline={isMultiLine(item.id.split('_')[1])}
                    // helperText={errorWorkerName.text}
                    // disabled={isDisabled}
                    // error={errorWorkerName.isShow}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        {processPvData.length > 0 && (
          <div className={classes.mainContents}>
            <Divider
              textAlign="left"
              sx={dividerStyle(
                user?.mode === 'lite'
                  ? colorSelectRuturnCodeLite('PV_')
                  : colorSelectRuturnCode('PV_')
              )}
              variant="fullWidth"
            >
              工程情報
            </Divider>
            <div className={classes.content}>
              {processPvData.map((item: any) => (
                <div key={item.id}>
                  <TextField
                    label={item.id.split('_')[1]}
                    variant="outlined"
                    value={item.text}
                    InputProps={{ readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                    sx={
                      !isMultiLine(item.id.split('_')[1])
                        ? inputStyleProcess(
                            item.id.split('_')[1],
                            user?.mode === 'lite'
                              ? colorSelectRuturnCodeLite('PV_')
                              : colorSelectRuturnCode('PV_'),
                            isFinished(item.text)
                          )
                        : inputMultiStyle(
                            item.id.split('_')[1],
                            user?.mode === 'lite'
                              ? colorSelectRuturnCodeLite('PV_')
                              : colorSelectRuturnCode('PV_')
                          )
                    }
                    multiline={isMultiLine(item.id.split('_')[1])}
                    // helperText={errorWorkerName.text}
                    // disabled={isDisabled}
                    // error={errorWorkerName.isShow}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        {siteData.length > 0 && (
          <div className={classes.mainContents}>
            <Divider
              textAlign="left"
              sx={dividerStyle(
                user?.mode === 'lite'
                  ? colorSelectRuturnCodeLite('S_')
                  : colorSelectRuturnCode('S_')
              )}
              variant="fullWidth"
            >
              現場情報
            </Divider>
            <div className={classes.content}>
              {siteData.map((item: any) => (
                <div key={item.id}>
                  <TextField
                    label={item.id.split('_')[1]}
                    variant="outlined"
                    value={item.text}
                    InputProps={{ readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                    sx={
                      !isMultiLine(item.id.split('_')[1])
                        ? inputStyleSite(
                            item.id.split('_')[1],
                            user?.mode === 'lite'
                              ? colorSelectRuturnCodeLite('S_')
                              : colorSelectRuturnCode('S_'),
                            isFinished(item.text)
                          )
                        : inputMultiStyle(
                            item.id.split('_')[1],
                            user?.mode === 'lite'
                              ? colorSelectRuturnCodeLite('S_')
                              : colorSelectRuturnCode('S_')
                          )
                    }
                    multiline={isMultiLine(item.id.split('_')[1])}
                    // helperText={errorWorkerName.text}
                    // disabled={isDisabled}
                    // error={errorWorkerName.isShow}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        {/* <h1>レコード詳細</h1> */}
        {baseData.length > 0 && (
          <div className={classes.mainContents}>
            <Divider
              textAlign="left"
              sx={dividerStyle(
                user?.mode === 'lite'
                  ? colorSelectRuturnCodeLite('B_')
                  : colorSelectRuturnCode('B_')
              )}
              variant="fullWidth"
            >
              受注情報
            </Divider>
            <div className={classes.content}>
              {baseData.map((item: any) => (
                <div key={item.id}>
                  <TextField
                    label={
                      item.id.split('_')[1] === 'レコード番号'
                        ? 'ﾚｺｰﾄﾞID'
                        : item.id.split('_')[1]
                    }
                    variant="outlined"
                    value={item.text}
                    InputProps={{ readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                    sx={
                      !isMultiLine(item.id.split('_')[1])
                        ? inputStyle(
                            item.id.split('_')[1],
                            user?.mode === 'lite'
                              ? colorSelectRuturnCodeLite('B_')
                              : colorSelectRuturnCode('B_')
                          )
                        : inputMultiStyle(
                            item.id.split('_')[1],
                            user?.mode === 'lite'
                              ? colorSelectRuturnCodeLite('B_')
                              : colorSelectRuturnCode('B_')
                          )
                    }
                    multiline={isMultiLine(item.id.split('_')[1])}
                    // helperText={errorWorkerName.text}
                    // disabled={isDisabled}
                    // error={errorWorkerName.isShow}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        {/* {siteData.length > 0 && baseData.length > 0 && (
          <div className={classes.mainContents}>
            <Divider
              textAlign="left"
              sx={dividerStyle(
                user?.mode === "lite"
                  ? colorSelectRuturnCodeLite("B_")
                  : colorSelectRuturnCode("B_")
              )}
              variant="fullWidth"
            >
              受注情報
            </Divider>
            <div className={classes.content}>
              {baseData.map((item: any) => (
                <div key={item.id}>
                  <TextField
                    label={item.id.split("_")[1]}
                    variant="outlined"
                    value={item.text}
                    InputProps={{ readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                    sx={
                      !isMultiLine(item.id.split("_")[1])
                        ? inputStyle(
                            item.id.split("_")[1],
                            user?.mode === "lite"
                              ? colorSelectRuturnCodeLite("B_")
                              : colorSelectRuturnCode("B_")
                          )
                        : inputMultiStyle(
                            item.id.split("_")[1],
                            user?.mode === "lite"
                              ? colorSelectRuturnCodeLite("B_")
                              : colorSelectRuturnCode("B_")
                          )
                    }
                    multiline={isMultiLine(item.id.split("_")[1])}
                    // helperText={errorWorkerName.text}
                    // disabled={isDisabled}
                    // error={errorWorkerName.isShow}
                  />
                </div>
              ))}
            </div>
          </div>
        )} */}
      </div>
    </Modal>
  )
}

export default RecordDetailForm
